import { useConfigSlice } from '../slices/config/selectors';

export const useHideCurrency = (): boolean => {
  const casinoConfig = useConfigSlice.casinoConfig();
  const compliance = useConfigSlice.compliance();

  return (compliance?.hideCurrency || casinoConfig?.hideCurrency) ?? false;
};
